import { IoNewspaper } from 'react-icons/io5'
import { Link } from 'react-router'
import { PATHS } from '@/navigation/paths'

/**
 * The header's link to the blog, right after search, for everyone signed in
 * or out (docs/plans/blog.md, Decision 10): Ionicons' filled newspaper, the
 * set the header's other icons come from. Both header menus place this one,
 * so the two cannot drift.
 */
const HeaderBlogLink = ({ dashboard }: { dashboard?: boolean }) => (
  <Link to={PATHS.blog} aria-label='Blog' data-testid='header-blog'>
    <IoNewspaper className={dashboard ? 'nav-dashboard-color' : undefined} />
  </Link>
)

export default HeaderBlogLink
